import React, { useContext } from "react";
import { 
  Col, 
  Row, 
  Button, 
  Input,
} from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import SubUserFilterCustom from "./subUserFilterCustom";
import SubUserStatementTableDropdown from "./subuserStatementTableDropdown";
import { StateContext } from "../utils/context";
import StatementUnavailbleTooltip from "./statementUnavailableTooltip";
import { sendAuditEvent } from "../utils/auditTrail";
import { useTranslation } from "react-i18next";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
 
const SubuserStatementTable = ({ tableData, setSuccess, setError, setToggleModal, setDataModal, setLastAction, forceUpdate, searchQuery, defaultSorted, subUserData, auditData }) => {  
  const { currentUser } = useContext(StateContext);
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const months = [
    t("subuserStatements.view.table.label.monthJanuary"),
    t("subuserStatements.view.table.label.monthFebruary"),
    t("subuserStatements.view.table.label.monthMarch"),
    t("subuserStatements.view.table.label.monthApril"),
    t("subuserStatements.view.table.label.monthMay"),
    t("subuserStatements.view.table.label.monthJune"),
    t("subuserStatements.view.table.label.monthJuly"),
    t("subuserStatements.view.table.label.monthAugust"),
    t("subuserStatements.view.table.label.monthSeptember"),
    t("subuserStatements.view.table.label.monthOctober"),
    t("subuserStatements.view.table.label.monthNovember"),
    t("subuserStatements.view.table.label.monthDecember")
  ];

  const currencies = ["€", "$", "£"];

  const monthFormatter = (cell, row) => {
    cell = months[cell - 1];
    return cell;
  };

  const amountFormatter = (cell, row) => `${cell}${currencies[row.currency]}`;

  const statusFormatter = cell =>
    cell === 0 ? (
      <Button className="btn-status" disabled color="warning">
        {t("subuserStatements.view.table.label.statusOpen")}
      </Button>
    ) : cell === 1 ? (
      <Button className="btn-status" disabled color="success">
        {t("subuserStatements.view.table.label.statusPaid")}
      </Button>
    ) : null;

  const typeFormatter = cell =>
    cell === 1 ? t("subuserStatements.view.table.label.typeLicensing") :
    cell === 2 ? t("subuserStatements.view.table.label.typeRegular") :
    cell === 3 ? t("subuserStatements.view.table.label.typeAudioMasteringServices") :
    cell === 4 ? t("subuserStatements.view.table.label.typeVinylEarnings") :
    cell === 5 ? t("subuserStatements.view.table.label.typeOffset") :
    t("subuserStatements.view.table.label.typeNotKnown");

  const downloadFormatter = (cell, row) =>
    cell ?
    (
      <a
        href={cell}
        target="blank"
        rel="noreferrer"
        onClick={() => {
          sendAuditEvent({
            token: auditData?.token,
            eventType: 5,
            route: auditData?.route || window.location.pathname,
            entityType: auditData?.entityType || "subuser_statement",
            entityIds: [row.id],
          });
        }}
      >
      <Button className="btn-status" color="primary">
        <b>{t("subuserStatements.view.table.button.download")}</b>
      </Button>
      </a>
    ) :
      <center>
        <StatementUnavailbleTooltip id={row.id} />
      </center>;

    const actionFormatter = (cell, row) => {
        return (
          <SubUserStatementTableDropdown
            data={{id: row.id, status: row.status, name: row.name}}
            setSuccess={setSuccess}
            setError={setError}
            setToggleModal={setToggleModal}
            setDataModal={setDataModal}
            setLastAction={setLastAction}
          />
        );
      };

  const columns = [
    {
      dataField: "sts_kind",
      text: t("subuserStatements.view.table.column.type"),
      sort: true,
      formatter: typeFormatter,
      csvFormatter: typeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      }
    },
    {
      dataField: "year",
      text: t("subuserStatements.view.table.column.year"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      }
    },
    {
      dataField: "month",
      text: t("subuserStatements.view.table.column.month"),
      sort: true,
      formatter: monthFormatter,
      csvFormatter: cell => months[cell - 1],
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      }
    },
    {
      dataField: "issue_year",
      text: t("subuserStatements.view.table.column.issue_year"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "issue_month",
      text: t("subuserStatements.view.table.column.issue_month"),
      sort: true,
      formatter: monthFormatter,
      csvFormatter: cell => months[cell - 1],
      headerStyle: (colum, colIndex) => {
        return { width: "110px" };
      }
    },
    {
      dataField: "short_description",
      text: t("subuserStatements.view.table.column.description"),
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      }
    },
    {
      dataField: "price",
      text: t("subuserStatements.view.table.column.amount"),
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "status",
      text: t("subuserStatements.view.table.column.status"),
      sort: true,
      formatter: statusFormatter,
      csvFormatter: cell =>
        cell === 0 ? "Open" : cell === 1 ? "  Paid" : null,
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "new_details",
      text: t("subuserStatements.view.table.column.details"),
      headerAlign: "center",
      align: "center",
      formatter: (cell, row) => downloadFormatter(cell, row),
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "new_overview",
      text: t("subuserStatements.view.table.column.overview"),
      headerAlign: "center",
      align: "center",
      formatter: (cell, row) => downloadFormatter(cell, row),
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
      dataField: "action",
      text: t("subuserStatements.view.table.column.action"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "111px" };
      }
    },

    //data for search
    {
      dataField: "status",
      sort: false,
      csvExport: false,
      hidden: true,
      formatter: cell => (cell === 0 ? "Open" : cell === 1 ? "Paid" : null)
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "kind" || sortField === "sts_kind" || sortField === "month" || sortField === "year" || sortField === "issue_month" || sortField === "issue_year" || sortField === "price") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
    if (sortField === "name") {
      searchQuery.setOrdering({order: ascDesc, name: "id", sort: sortField});
    }
  }


  return (
    <div>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
        search={{
          searchFormatted: true
        }}
        exportCSV={ {
          fileName: "subuser-statements.csv",
        } }
      >
        {props => (
          <div>
            <Row>
              <Col>
                <div className="customSearch">
                  <Input placeholder={t("subuserStatements.view.table.placeholder.search")} value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
                </div>
              </Col>
              {
                currentUser.is_premium_user && <SubUserFilterCustom subUserData={subUserData} />
              }
              <Col>
                <div className="flexEndContainer">
                                 
                  <ExportCSVButton
                    className="btn btn-outline-info"
                    {...props.csvProps}
                  >
                    {t("subuserStatements.view.table.button.export_csv")}
                  </ExportCSVButton>
                </div>
              </Col>
            </Row>
            <BootstrapTable
              {...props.baseProps}
              bordered={ false }
              remote={ { sort: true } }
              defaultSorted={defaultSorted}
              onTableChange={handleTableChange}
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default SubuserStatementTable;
